(ns measure.report-builder.view.tree
  (:require ["@mui/material/Chip$default" :as Chip]
            ["@mui/material/Stack$default" :as Stack]
            ["@mui/material/SvgIcon$default" :as SvgIcon]
            ["@mui/material/Tooltip$default" :as Tooltip]
            ["@mui/material/Typography$default" :as Typography]
            ["@mui/x-tree-view/RichTreeView" :refer [RichTreeView]]
            ["@mui/x-tree-view/TreeItem" :refer [TreeItem]]
            ["@mui/x-tree-view/hooks" :refer [useTreeItemModel]]
            ["react-hook-form" :as rhf]
            [cljs-bean.core :refer [->clj ->js]]
            [common.util :refer [spread-props]]
            [uix.core :as uix :refer [$ defui]]))

(defn- is-item-selection-disabled [^js item]
  (seq (.-children item)))

(def CustomTreeItemLabel
  (uix/as-react
   (fn [{:keys [className children icon selected-count tooltip]}]
     ($ Stack
        {:className className
         :direction "row"
         :gap 0.5
         :sx #js {:flex 1
                  :alignItems "center"}}
        (when icon
          ($ SvgIcon {:inheritViewBox true} icon))
        (if tooltip
          ($ Tooltip {:title tooltip :placement "right"}
             ($ Typography {:sx #js {:flex 1}} children))
          ($ Typography {:sx #js {:flex 1}} children))
        (when (pos? selected-count)
          ($ Chip
             {:label selected-count
              :size "small"
              :sx #js {:ml "auto"}}))))))

(defn CustomTreeItem [^js props]
  (let [item (useTreeItemModel (.-itemId props))
        selected-values (.-selectedValues props)
        children (->clj (.-children item))
        selected-count (when (seq children)
                         (count (filter #(contains? selected-values (:id %)) children)))]
    ($ TreeItem
       (spread-props props
                     {:slots #js {:label CustomTreeItemLabel}
                      :slotProps #js {:label #js {:icon (.-icon item)
                                                  :selected-count selected-count
                                                  :tooltip (.-tooltip item)}}
                      :sx #js {:mt 1
                               ".MuiTreeItem-content[data-selected]" #js {:backgroundColor "unset"}}}))))

(defui tree-view [{:keys [field-name control tree-items]}]
  ($ rhf/Controller
     {:control control
      :name field-name
      :render (fn [^js props]
                (let [{{:keys [value onChange]} :field} (->clj props)
                      selected-values (set value)]
                  ($ RichTreeView
                     {:items (->js tree-items)
                      :checkboxSelection true
                      :selectedItems (->js value)
                      :onSelectedItemsChange (fn [_e ids]
                                               (onChange ids))
                      :isItemSelectionDisabled is-item-selection-disabled
                      :multiSelect true
                      :slots #js {:item CustomTreeItem}
                      :slotProps #js {:item #js {:selectedValues selected-values}}
                      :sx #js {:overflow "auto"
                               :mt 3}})))}))
